import { useQuery } from '@tanstack/react-query';
import type { VideoAutoConfig } from '@news-cms/shared';
import { Label } from '@/components/ui/label';
import { groupContentsVideoPlaylistsQueryOptions } from '@/lib/group-contents';

interface Props {
  config: VideoAutoConfig;
  onChange: (next: VideoAutoConfig) => void;
}

export function ConfigEditorVideoAuto({ config, onChange }: Props) {
  const playlistsQuery = useQuery(groupContentsVideoPlaylistsQueryOptions);
  const playlists = playlistsQuery.data ?? [];

  return (
    <div className="space-y-4">
      <div className="space-y-1.5">
        <Label htmlFor="video-playlist">Playlist</Label>
        <select
          id="video-playlist"
          value={config.playlistId ?? ''}
          onChange={(e) => onChange({ ...config, playlistId: e.target.value || null })}
          className="border-input bg-background h-10 w-full rounded-md border px-3 text-sm"
        >
          <option value="">ทุก playlist</option>
          {playlists.map((pl) => (
            <option key={pl.id} value={pl.id}>
              {pl.name}
            </option>
          ))}
        </select>
        <p className="text-xs text-slate-500">ว่าง = ไม่กรอง — ดึงจากทุก playlist ที่ active</p>
      </div>

      <div className="space-y-1.5">
        <Label htmlFor="video-sort">เรียงตาม</Label>
        <select
          id="video-sort"
          value={config.sort}
          onChange={(e) => onChange({ ...config, sort: e.target.value as 'latest' | 'playlist' })}
          className="border-input bg-background h-10 w-full rounded-md border px-3 text-sm"
        >
          <option value="latest">ล่าสุด (วันเผยแพร่)</option>
          <option value="playlist">ตามลำดับใน playlist</option>
        </select>
        <p className="text-xs text-slate-500">
          "ตามลำดับใน playlist" = ตรงกับลำดับที่เห็นในหน้า playlist (position)
        </p>
      </div>
    </div>
  );
}
